import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { IncotermPrice } from '@app/generated/graphql';
import { Bind } from 'primeng/bind';
import { TableModule } from 'primeng/table';
import { DecimalPipe } from '@angular/common';

export interface PriceBreakdownItem {
  name: string;
  amount: string;
  currencySymbol: string;
}

@Component({
  selector: 'ag-price-breakdown',
  templateUrl: './price-breakdown.component.html',
  styleUrls: ['./price-breakdown.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, TableModule, DecimalPipe],
})
export class PriceBreakdownComponent {
  readonly priceItems = input<IncotermPrice[]>([]);

  readonly verboseBreakdown = input<boolean>(false);
}
